import {
    getCountry,
    getLanguage,
    getSupportedLanguages
} from '@dazn/lp-web/src/utils/dazn/Region';

export const getPathParts = (pathname: string): string[] => {
    const [, locale, ...restSegments] = pathname.split('/');
    const restPath = restSegments.join('/');

    return [locale, restPath];
};

export const getLocaleString = (language: string, country: string): string =>
    `${language}-${country.toUpperCase()}`;

const useLanguages = () => {
    const supportedLanguages = getSupportedLanguages();
    const languages = supportedLanguages
        .map((language) => ({
            value: language,
            href: setLanguage(language)
        }))
        .filter((language) => language.value !== getLanguage());

    function setLanguage(language: string) {
        const country = getCountry();
        const locale = getLocaleString(language, country);
        const {pathname, origin, search} = window.location;
        const [, restPath] = getPathParts(pathname);
        const {href} = new URL(`${locale}/${restPath}${search}`, origin);
        return href;
    }
    return {languages};
};

export {useLanguages};
